import React, { Component } from'react';

import { SubHeading } from 'web-ui-components/lib/typography/headings';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { IconTextDynamic } from 'web-ui-components/lib/molecules/icon-text-dynamic';
import { PhoneLink } from 'web-ui-components/lib/actions/links';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
 
class RightPanel extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { contactPanel } = this.props;
        const { needHelp, callUsOn, contactNumber, orAbroad, abroadContactNumber, timingsLink, timingsText} = contactPanel;
        return (
            <>
                <div>
                    <Card>
                        <IconTextDynamic iconType="MobileOutlineLarge">
                            <SubHeading>{needHelp}</SubHeading>
                        </IconTextDynamic>
                            {callUsOn}
                        <div>
                            <PhoneLink phoneNumber={contactNumber} />
                        </div>
                            {orAbroad}
                        <div>
                            <PhoneLink phoneNumber={abroadContactNumber} />
                        </div>
                        <WebsiteLink linkText={timingsText} linkTitle={timingsText} url={timingsLink} willOpenNewWindow />
                    </Card>
                </div>
            </>
        );
    }
} 

export default RightPanel;
